import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface Venue {
  id?: string;
  venue_id?: string;
  name: string;
  base_price?: string | number;
  capacity?: string | number;
  floor_area?: string | number;
  image?: string;
  venue_type?: string;
  amenities?: string[] | string;
  description?: string;
  is_active?: boolean;
}

export interface VenueState {
  venues: Venue[];
  isFetching: boolean;
  error: string | null;
}

const initialState: VenueState = {
  venues: [],
  isFetching: false,
  error: null,
};

const venueSlice = createSlice({
  name: "venues",
  initialState,
  reducers: {
    setVenues: (state, action: PayloadAction<Venue[]>) => {
      state.venues = action.payload;
      state.isFetching = false;
      state.error = null;
    },
    setFetching: (state, action: PayloadAction<boolean>) => {
      state.isFetching = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isFetching = false;
    },
  },
});

export const { setVenues, setFetching, setError } = venueSlice.actions;
export default venueSlice.reducer;
